import axiosInstance from "@/lib/axios";

export const liveService = {
  getLives: async (params = {}) => {
    const response = await axiosInstance.get("/api/v1/admin/lives", { params });
    return response.data;
  },

  endLive: async (id) => {
    const response = await axiosInstance.post(`/api/v1/admin/lives/${id}/end`);
    return response.data;
  },

  getParticipants: async (id) => {
    const response = await axiosInstance.get(
      `/api/v1/admin/lives/${id}/participants`
    );
    return response.data;
  },

  banParticipant: async (id, userId, reason) => {
    const response = await axiosInstance.post(`/api/v1/admin/lives/${id}/ban`, {
      user_id: userId,
      ...(reason ? { reason } : {}),
    });
    return response.data;
  },
};
